import type { RouteRecordRaw, Router } from 'vue-router'

const BreachOfTrustRoutes: RouteRecordRaw = {
  path: '/claim/breachOfTrust',
  name: 'BreachOfTrustModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'BreachOfTrustMainRoute',
      component: () => import('./views/BreachOfTrustView.vue'),
      meta: {
        title: 'breachOfTrust.breachOfTrustClaims',
      },
    },
    {
      path: 'create',
      name: 'BreachOfTrustCreateRoute',
      component: () => import('./views/BreachOfTrustUpsertView.vue'),
      meta: {
        title: 'breachOfTrust.createBreachOfTrust',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:breachOfTrustId',
      name: 'BreachOfTrustEditRoute',
      component: () => import('./views/BreachOfTrustUpsertView.vue'),
      meta: {
        title: 'breachOfTrust.editBreachOfTrust',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:breachOfTrustId',
      name: 'ViewBreachOfTrustRoute',
      component: () => import('./views/SingleBreachOfTrustView.vue'),
      meta: {
        title: 'breachOfTrust.ViewBreachOfTrust',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BreachOfTrustRoutes)
}
